import { render, staticRenderFns } from "./content-navigation.vue?vue&type=template&id=44ea6700&scoped=true&"
import script from "./content-navigation.vue?vue&type=script&lang=ts&"
export * from "./content-navigation.vue?vue&type=script&lang=ts&"
import style0 from "./content-navigation.vue?vue&type=style&index=0&id=44ea6700&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44ea6700",
  null
  
)

export default component.exports